import Nav from "@/sections/nav";
import { Outlet } from "react-router";

export default function RootLayout() {
  return (
    <div className="relative flex min-h-dvh flex-col overflow-clip">
      {/* We can keep Nav it here for now */}
      <Nav />
      <main className="relative grow">
        <Outlet />
      </main>
    </div>
  );
}
